import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import UpdateUserForm from './UpdateUserForm'
import Footer from '../others/Footer';
import { Row, Col, Avatar, Switch, Tag, Badge, Icon, Drawer, Modal, Table, Tooltip, Button } from 'antd';
import UserFormPassword from './UserFormPassword';
import API, { IMAGES_URL } from '../../helper/api/Api';
import Item from '../event/Item';
import { url, urlPublic, urlLogOut } from '../../helper/image';
import { Link } from 'react-router-dom';
import moment from 'moment';

const DRAWER = {
  INFO: "INFORMATIONS GÉNÉRALES",
  MDP: "RÉINITIALISER LE MOT DE PASSE"
}

export class Profil extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    loading: true,
    events: [],
    drawerPage: DRAWER.INFO,
    visible_drawer: false,
    visible_modal: false,
    id_modal: null
  }


  showModal = (show, id = this.state.id_modal) => {
    this.setState({
      visible_modal: show,
      id_modal: id
    });
  }

  showDrawer = (show, view = this.state.drawerPage) => {
    this.setState({
      visible_drawer: show,
      drawerPage: view
    });
  };

  traductionToFr(string) {
    switch (string) {
      case "ForeignersStudents":
        return "Profil invité";
        break;
      case "Not From School":
        return "Vous n'êtes pas un étudiant Ynov";
        break
      case "Student":
        return "Étudiant";
        break
      case "Admin":
        return "Administrateur";
        break
      case "Admin":
        return "Administrateur";
        break
    }
  }

  componentDidMount() {
    this.props.actions.getUser();
    API.get('booking').then(res => this.setState({ events: res.data, loading: false }))
  }

  render() {
    console.log(this.state)
    return (
      
      <div className="user-profil">

        <div className="header-profil">
          <Col xs={{ span: 22, offset: 1 }} className="center" >
            <Col xs={{ span: 8 }} sm={{ span: 4 }} md={{ span: 3 }}>
              <Link to={process.env.PUBLIC_URL}>
                <img src={url("logo/logo-gray.svg")}></img>
              </Link>
            </Col>
            <Col xs={{ span: 8 }} sm={{ span: 4 }} md={{ span: 18 }}>

            </Col>
            <Col className="center" xs={{ span: 8 }} sm={{ span: 4 }} md={{ span: 3 }}>
            <Link to="../auth/signout">
              <Button type="primary" icon="poweroff" >
                Déconnexion
              </Button>
            </Link>
            </Col>
          </Col>
        </div >

        <Row align="middle" style={{ paddingTop: '30px' }}>
          <Col xs={{ span: 22, offset: 1 }}>
            <Col className="bloc-profil" style={{ padding: '2% 0 0 0' }} xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }} xl={{ span: 6 }}>
              <Row style={{ padding: '0 30px 44px 0' }}>
                <Col style={{ textAlign: 'center' }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
                  <Badge count={this.props.user.role.name}>
                    <Avatar
                      size={64}
                      shape="square"
                      icon="user"
                      src={IMAGES_URL(this.props.user.imageUrl)}
                    />
                  </Badge>
                </Col>
                <Col style={{ textAlign: 'center' }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 16 }}>
                  <Col span={24}>
                    <h1>{this.props.user.firstName + ' ' + this.props.user.lastName}</h1>
                  </Col>
                  <Col span={24}>
                    <h2>{this.props.user.promotion.name} - {this.props.user.promotion.description}</h2>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Tooltip placement="bottom" title='Mot de passe'>
                  <Col onClick={() => this.showDrawer(true, DRAWER.MDP)} className="bloc-password" style={{ textAlign: 'center' }} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <p><Icon type="unlock" /></p>
                  </Col>
                </Tooltip>
                <Tooltip placement="bottom" title='Informations générales'>
                  <Col onClick={() => this.showDrawer(true, DRAWER.INFO)} className="bloc-setting" style={{ textAlign: 'center' }} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <p><Icon type="setting" /></p>
                  </Col>
                </Tooltip>
              </Row>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 14 }} xl={{ span: 18 }} >
              <Row type="flex" justify="center">
                <Col className="bloc-admin" style={{ padding: '4%', minHeight: '194px' }} xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
                  <Col className="bloc-admin-informations" style={{ fontSize: '35px' }} span={24}>
                    <p>{this.props.user.totalJuryPoints}</p>
                  </Col>
                  <Col className="bloc-admin-informations" span={24}>
                    <p>points jury</p>
                  </Col>
                </Col>
                <Col className="bloc-admin" style={{ padding: '4%', minHeight: '194px' }} xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
                  <Col className="bloc-admin-informations" style={{ fontSize: '35px' }} span={24}>
                    <p>{this.state.events.filter(e => e.present).length}</p>
                  </Col>
                  <Col className="bloc-admin-informations" span={24}>
                    <p>participations</p>
                  </Col>
                </Col>
              </Row>
            </Col>
          </Col>
        </Row>

        <Row style={{ margin: '50px 80px' }} type="flex" justify="space-around">
          <Col className="bloc-profil-events" xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
            <h1 style={{ textTransform : 'uppercase' }}>événements à venir</h1>
            <Table
              onRow={(record) => ({
                onClick: () => this.showModal(true, record.event.id)       // click row
              })}
              showHeader={false}
              pagination={this.state.events.length > 10 ? { position: 'bottom' } : false}
              columns={
                [
                  {
                    title: 'Image',
                    dataIndex: 'event',
                    key: 'images',
                    width: '40px',
                    render: event => <Avatar src={IMAGES_URL(event.images)} />
                  }, {
                    title: 'Title',
                    dataIndex: 'event',
                    key: 'title',
                    render: event => event.title
                  }, {
                    title: 'Date',
                    dataIndex: 'event',
                    key: 'date',
                    render: event => <Tag color="red"> {moment(event.openAt).format('DD MMMM YYYY')} </Tag>
                  }, {
                    title: 'Status',
                    dataIndex: 'event',
                    key: 'event',
                    render: event => <Tag color="volcano"> {event.status} </Tag>
                  }, {
                    title: 'Categories',
                    dataIndex: 'event',
                    key: 'categories',
                    render: event => (
                      event.eventCategory.map(c => <Tag>{c.category.name}</Tag>)
                    ),
                  }, {
                    title: 'Status',
                    dataIndex: 'validated',
                    key: 'status',
                    width: '100px',
                    render: validated => (
                      validated == null ? '' : <Tag color={validated ? "green" : "orange"}>{validated ? "Validé" : "En attente"}</Tag>
                    ),
                  }, {
                    title: 'juryPoint',
                    dataIndex: 'event',
                    key: 'juryPoint',
                    width: '100px',
                    render: event => (
                      event.juryPoint === 0 || event.juryPoint === null ? '' : <Tag color="green">{event.juryPoint}  {event.juryPoint > 1 ? "points jury" : "point jury"}</Tag>
                    ),
                  }, {
                    title: 'notification',
                    dataIndex: 'event',
                    key: 'notification',
                    width: '100px',
                    render: event => <Switch defaultChecked disabled />,
                  }
                ]}
              dataSource={this.state.events.filter(e => e.event.status !== 'done')} />
          </Col>
          <Col className="bloc-profil-events" style={{ marginTop: '40px' }} xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
            <h1 style={{ textTransform : 'uppercase' }}>événements passés</h1>
            <Table
              onRow={(record) => ({
                onClick: () => this.showModal(true, record.event.id)       // click row
              })}
              showHeader={false}
              pagination={this.state.events.length > 10 ? { position: 'bottom' } : false}
              columns={
                [
                  {
                    title: 'Image',
                    dataIndex: 'event',
                    key: 'images',
                    width: '40px',
                    render: event => <Avatar src={IMAGES_URL(event.images)} />
                  }, {
                    title: 'Title',
                    dataIndex: 'event',
                    key: 'title',
                    render: event => event.title
                  }, {
                    title: 'Categories',
                    dataIndex: 'event',
                    key: 'categories',
                    render: event => (
                      event.eventCategory.map(c => <Tag>{c.category.name}</Tag>)
                    ),
                  }, {
                    title: 'Status',
                    dataIndex: 'present',
                    key: 'status',
                    width: '100px',
                    render: present => (
                      <Tag color={present ? "green" : "orange"}>{present ? "Présent" : "Absent"}</Tag>
                    ),
                  }, {
                    title: 'juryPoint',
                    dataIndex: 'event',
                    key: 'juryPoint',
                    width: '100px',
                    render: event => (
                      event.juryPoint === 0 || event.juryPoint === null ? '' : <Tag>{event.juryPoint}  {event.juryPoint > 1 ? "points jury" : "point jury"}</Tag>
                    ),
                  }
                ]}
              dataSource={this.state.events.filter(e => e.event.status === 'done')} />
          </Col>
        </Row>

        <Drawer
          title={this.state.drawerPage}
          className="widthDrawer"
          placement="right"
          onClose={() => this.showDrawer(false)}
          visible={this.state.visible_drawer}
          style={{
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: 53,
          }}
        >
          {
            this.state.drawerPage === DRAWER.INFO ?
              <UpdateUserForm user={this.props.user} onSend={() => this.showDrawer(false)} />
              :
              <UserFormPassword onSend={() => this.showDrawer(false)} />
          }
        </Drawer>

        <Modal
          className="modal-event"
          visible={this.state.visible_modal}
          onOk={() => this.showModal(false)}
          onCancel={() => this.showModal(false)}
        >
          <Item id={this.state.id_modal} />
        </Modal>

        <Footer />
      </div >
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user.user,
    status: state.user.status
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profil);



// WEBPACK FOOTER //
// ./src/features/user/Profil.js